import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPrefs } from "~/redux/actions/app";

/**
 * 使用缓存的 prefs 数据的 Hook
 * @param {boolean} forceRefresh - 是否强制刷新缓存
 * @returns {Object} prefs 数据
 */
const usePrefs = (forceRefresh = false) => {
  const dispatch = useDispatch();
  const prefs = useSelector((state) => state.app.prefs);
  const prefsTimestamp = useSelector((state) => state.app.prefsTimestamp);

  useEffect(() => {
    // 组件挂载时检查并获取 prefs
    dispatch(getPrefs(forceRefresh));
  }, [dispatch, forceRefresh]);

  // 提供手动刷新方法
  const refreshPrefs = () => {
    return dispatch(getPrefs(true));
  };

  return {
    prefs,
    prefsTimestamp,
    refreshPrefs,
  };
};

export default usePrefs;
